import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

export const useStyles = ({
  custom: {
    palette: { colorSupportPowder, colorSupportSlate },
  },
  palette: { divider },
  transitions: { create: createTransition, easing, duration },
  spacing: { unit },
  breakpoints,
  mixins: { toolbar },
}: Theme) =>
  createStyles({
    listRoot: {
      flexGrow: 0.87,
    },
    root: {
      display: 'flex',
    },
    drawerNexty: {
      marginTop: '65px !important',
      height: 'calc(100% - 64px)',
      width: 218,
      flexShrink: 0,
      whiteSpace: 'nowrap',
    },
    drawer: {
      width: 218,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      marginTop: 60,
    },
    drawerOpen: {
      width: 218,
      transition: createTransition('width', {
        easing: easing.sharp,
        duration: duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: createTransition('width', {
        easing: easing.sharp,
        duration: duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: unit * 8,
      [breakpoints.up('sm')]: {
        width: unit * 10,
      },
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: `0 ${unit}px 0 ${unit * 3}px`,
      ...toolbar,
    },
    toolbarClosed: {
      padding: `0 ${unit}px`,
      justifyContent: 'center',
    },
    listItem: {
      borderLeft: `4px solid transparent`,
      paddingRight: unit,
      paddingLeft: unit * 3 - 4, // Subtract border width
      '&$listItemSelected': {
        borderLeft: `4px solid ${colorSupportSlate}`,
        backgroundColor: colorSupportPowder,
        '&:hover': {
          backgroundColor: colorSupportPowder,
        },
        '&:focus': {
          backgroundColor: colorSupportPowder,
        },
      },
    },
    listItemSelected: {},
    content: {
      flexGrow: 1,
      padding: unit * 3,
    },
    listItemText: {
      display: 'flex',
      justifyContent: 'space-between',
      transition: 'opacity 0.2s ease-out',
      alignItems: 'center',
    },
    listItemTextRoot: {
      padding: 0,
    },
    hide: {
      opacity: 0,
    },
    menuToggle: {
      width: unit * 3.5,
      height: unit * 3.5,
    },
    icon: {
      width: unit * 2,
      height: unit * 2,
    },
    arrow: {
      marginTop: 2,
    },
    lastItem: {
      marginBottom: unit * 8,
      borderLeft: `4px solid transparent`,
      paddingLeft: unit,
      paddingRight: unit * 4,
    },
  });
